import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  input,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { fromEvent, of, Subscription } from 'rxjs';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  standalone: false,
  selector: 'ti-copy-link',
  templateUrl: './copy-link.component.html',
  styleUrls: ['./copy-link.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyLinkComponent implements AfterViewInit, OnDestroy {
  @Input() set itemId(itemId: string | number) {
    this._itemId = String(itemId);
  }
  @Input() set link(link: string) {
    this._link = link;
  }
  hasAccess = input<boolean>(true);

  _itemId: string = '';
  _link: string = window.location.href;

  public readonly miscStrings = tiStrings.app.misc;
  public isLinkCopied: boolean = false;

  private subscription: Subscription;

  @ViewChild('copyLink') copyLinkRef: ElementRef;

  constructor(
    private clipboard: Clipboard,
    private cdr: ChangeDetectorRef,
  ) {}

  ngAfterViewInit(): void {
    const mousedown$ = fromEvent(this.copyLinkRef.nativeElement, 'mousedown');
    const mouseup$ = fromEvent(this.copyLinkRef.nativeElement, 'mouseup');

    this.subscription = mousedown$
      .pipe(
        mergeMap((event: MouseEvent) => {
          event.stopPropagation();
          return of(event).pipe(takeUntil(mouseup$));
        }),
      )
      .subscribe((event: MouseEvent) => {
        this.hasAccess() && this.copyLink();
      });
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }

  private copyLink(): void {
    this.clipboard.copy(this._link);
    this.isLinkCopied = true;
    this.cdr.markForCheck();
    setTimeout(() => {
      this.isLinkCopied = false;
      this.cdr.markForCheck();
    }, 2000);
  }
}
